import React, { Component } from 'react';
import PropTypes from "prop-types"; 
import AuthService from '../service/AuthService' ;

class LoginComponent extends Component{

    constructor(props) {
        super(props);
        this.handleLogin = this.handleLogin.bind(this);
        this.onChangeUsername = this.onChangeUsername.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
    
        this.state = {
          username: "",
          password: "",
          message: "",
          loading: false
        };
      }
    
      onChangeUsername(e) {
        this.setState({
          username: e.target.value
        });
      }
    
      onChangePassword(e) {
        this.setState({
          password: e.target.value
        });
      }
    
      handleLogin(e) {
        e.preventDefault();
    
        this.setState({
          message: "",
          loading: true
        });
    
        // validation des form à rajouter
        AuthService.login(this.state.username, this.state.password)
        .then(
          response => {
              let isSucessful = response.errorMessage ? false : true;
             
              if (isSucessful) {
                  this.setState({
                      loading: false
                      });
                  this.getUser();
                  this.props.history.push("/profile");
                  
                  //window.location.reload(); 
              }
              else
                  this.setState({
                  loading: false,
                  message: response.errorMessage
                  });
              
          }
        );
      }
    
    getUser = e => {
        this.props.getCurrentUser && this.props.getCurrentUser(e);
      };

    render() {
        return(

            <div class="py-5 text-center" style={style2}>
             <div class="container">
                <div class="row"> 
                <div class="mx-auto col-md-6 col-10 bg-white p-5">
                <i class="d-block fa fa-4x mb-2 text-body fa-user-o"></i>
                {this.state.message && (
              <div>
                <div className= "alert alert-danger alert-dismissible"
                  style = {{'white-space': 'pre-wrap'}}
                  role="alert"
                >
                  <strong>KO! </strong>
                  {this.state.message}
                </div>
              </div>
            )}
                <form>
                <div class="form-group">
                <div class="form-group"> <input type="text" class="form-control" placeholder="Saisir votre username" id="username" value={this.state.username} onChange={this.onChangeUsername}/>
            </div>
            <div class="form-group mb-3"> <input type="password" class="form-control" placeholder="Saisir votre mot de passe" id="password" value={this.state.password} onChange={this.onChangePassword}/>  </div> 
            <button  class="btn btn-info btn-block" onClick={this.handleLogin} 
                disabled={this.state.loading}>Login</button>
                </div>
                {this.state.loading && (<span className="spinner-border spinner-border-sm"></span> )}
                </form>
                </div>
                </div>
             </div>
          </div>

        );
    }
}




const style2={
"background-image": "linear-gradient(to left bottom, rgba(189, 195, 199, .75), rgba(44, 62, 80, .75))",
"background-size": "100%"
}
LoginComponent.propTypes = {
  getCurrentUser: PropTypes.func.isRequired
};
export default LoginComponent;